import React from 'react';

import { LinkButton, StandardButton } from '@eika/button';

import { Piwik, SiteCoreDictionary } from '../types';

import './Footer.scss';

interface FooterProps {
    next: () => void;
    cancel: () => void;
    dictionary: SiteCoreDictionary;
    piwik: Piwik | undefined;
}

const Footer = ({ next, cancel, dictionary, piwik }: FooterProps) => {
    const { formNext, formCancel } = dictionary;

    return (
        <div className="hard-block-card-button-row">
            <LinkButton
                data-track-id={piwik?.blockCardForm?.blockCardCancel?.dataTrackId}
                data-track-linkname={piwik?.blockCardForm?.blockCardCancel?.dataTrackLinkname}
                id={piwik?.blockCardForm?.blockCardCancel?.dataTrackId}
                onClick={() => cancel()}
            >
                {formCancel}
            </LinkButton>
            <StandardButton
                data-track-id={piwik?.blockCardForm?.blockCardNext?.dataTrackId}
                data-track-linkname={piwik?.blockCardForm?.blockCardNext?.dataTrackLinkname}
                id={piwik?.blockCardForm?.blockCardNext?.dataTrackId}
                onClick={() => next()}
            >
                {formNext}
            </StandardButton>
        </div>
    );
};

export default Footer;
